import { render, staticRenderFns } from "./AssignCouponModal.vue?vue&type=template&id=313c79d8"
import script from "./AssignCouponModal.vue?vue&type=script&lang=js"
export * from "./AssignCouponModal.vue?vue&type=script&lang=js"
import style0 from "./AssignCouponModal.vue?vue&type=style&index=0&id=313c79d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports